<template>
  <div
    class="flex shrink-0 items-center justify-center rounded-full font-medium uppercase select-none"
    :class="[
      sizeClasses,
      `bg-${teamColor}-90 text-${teamColor}-30 dark:bg-${teamColor}-30 dark:text-${teamColor}-90`,
    ]"
  >
    <template v-if="size == '18'">
      <BaseIcon size="12">group</BaseIcon>
    </template>
    <template v-else>
      {{ letters }}
    </template>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { colorForSeed } from '@/core/composables/useColorForMember'
  import { teamAbbreviation } from '@/core/models/team/team'
  import type { AvatarSize } from './avatar-props'
  import BaseIcon from '../icon/BaseIcon.vue'

  interface Props {
    name: string
    size?: AvatarSize | '18'
  }

  const { size = '40', name } = defineProps<Props>()

  const teamColor = computed(() => colorForSeed(name))
  const letters = computed(() => teamAbbreviation(name))

  const sizeClasses = computed(() => {
    if (size == '18') {
      return 'h-4.5 w-4.5'
    }
    if (size == '24') {
      return 'h-6 w-6 text-[8px] leading-none'
    }
    if (size == '32') {
      return 'h-8 w-8 text-[10px] leading-none'
    }
    return 'h-10 w-10 text-label-medium leading-none'
  })
</script>
